// extracted by mini-css-extract-plugin
module.exports = {"header":"modal-header_header__1zn1y","title":"modal-header_title__2p-8W"};